var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    d: "M12 6h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2m0 4h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2M7 6h1a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m0 4h1a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2m12 8h-1V1a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v17H1a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2m-8 0H9v-4h2zm5 0h-3v-5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v5H4V2h12z"
  })));
};
export default SvgBuilding;